<template>
  <preview-input-string :name="name" :value="value" :maxLength="70" />
</template>

<script>
import PreviewInputString from "./preview-input-string.vue";

export default {
  name: "PreviewInputSelectOne",
  props: {
    value: String,
    name: String
  },
  components: { PreviewInputString }
};
</script>
